import {ContainerType, containerTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<ContainerType>;

export const ContainerTypeSelect = (props: Props) => {
  const {options = containerTypes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
